
import { defineComponent } from "vue";

export default defineComponent({
  name: 'Api',
  props: {
    msg: String
  },
  components: {},
  computed: {
      apiSrc () {
        return '//tide-wht.holoworld.com.cn/docs/index.html';
      }
  },
  data () {
    return {
    
    }
  }
})
